import { CHANGE_ZOOID, CHANGE_ZOONAME, TOGGLE_ANONYMOUS, TOGGLE_ANONYMOUS_PHOTOS } from '../actions/actions';
import { SET_ZOO_TIER, SET_USER_ROLE, SET_ZONE_FILTER, SET_USER_FILTER, SET_ZOO_TIMEZONE, SET_ZOO_OPTIONS, SET_ZOO_TYPE, SET_AKONGO_STAFF } from '../actions/zoo.actions';

// Vérifier s'il y a un tier temporaire stocké dans localStorage
const getTempTier = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
        const tempTier = localStorage.getItem('tempZooTier');
        if (tempTier) {
            console.log('ZOO_REDUCER: Found temp tier in localStorage:', tempTier);
            return tempTier;
        }
    }
    return "essential"; // Valeur par défaut
};

// Récupérer le filtre zone depuis localStorage
const getStoredZoneFilter = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
        const storedFilter = localStorage.getItem('zoneFilter');
        if (storedFilter) {
            try {
                return JSON.parse(storedFilter);
            } catch (e) {
                return null;
            }
        }
    }
    return null;
};

// Récupérer le filtre utilisateur depuis localStorage
const getStoredUserFilter = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
        const storedFilter = localStorage.getItem('userFilter');
        if (storedFilter) {
            try {
                return JSON.parse(storedFilter);
            } catch (e) {
                return null;
            }
        }
    }
    return null;
};

const initialSettings = {
    /* Layout fixed. Scroll content only */
    zooId: "akongo",
    zooName: "Environnement de test",
    anonymousMode: false,
    anonymousModePhotos: true, // sous-option du mode démo : photos factices
    zooTier: getTempTier(), // Utiliser le tier temporaire s'il existe
    userRole: "user", // Rôle utilisateur par défaut
    zoneFilter: getStoredZoneFilter(), // Filtre par zone/secteur (null = tous)
    userFilter: getStoredUserFilter(), // Filtre par utilisateur/collecteur (null = tous)
    timezone: null, // IANA timezone string (e.g., "Europe/Paris") - loaded from zoo document
    productScopeReady: false,
    productScopeSelectionPending: false,
    productScopeSelectionRevision: 0,
    zooOptions: {}, // Options du zoo (tourneeEnabled, etc.)
    zooType: null, // "zoo" | "lab" | "projet" — drives i18n overlay (lab vocabulary)
    akongoStaff: false, // users/{uid}.akongoStaff — seul critère d'accès à l'interface V2
};

const zooReducer = (state = initialSettings, action) => {
    switch (action.type) {
        case CHANGE_ZOOID:
            return {
                ...state,
                zooId: action.value,
                ...(state.zooId !== action.value ? { zooOptions: {}, productScopeReady: false, productScopeSelectionPending: true, productScopeSelectionRevision: (state.productScopeSelectionRevision || 0) + 1 } : {}),
            };
        case CHANGE_ZOONAME:
            return {
                ...state,
                zooName: action.value
            };
        case TOGGLE_ANONYMOUS:

            console.log("step 2")
            console.log(action)

            return {
                ...state,
                anonymousMode: action.value
            };
        case TOGGLE_ANONYMOUS_PHOTOS:
            return {
                ...state,
                anonymousModePhotos: action.value
            };
        case SET_ZOO_TIER:
            console.log('ZOO_REDUCER: Setting zoo tier to:', action.value);
            return {
                ...state,
                zooTier: action.value
            };
        case SET_USER_ROLE:
            console.log('ZOO_REDUCER: Setting user role to:', action.value);
            return {
                ...state,
                userRole: action.value
            };
        case SET_ZONE_FILTER:
            console.log('ZOO_REDUCER: Setting zone filter to:', action.value);
            // Persister dans localStorage
            if (typeof window !== 'undefined' && window.localStorage) {
                if (action.value) {
                    localStorage.setItem('zoneFilter', JSON.stringify(action.value));
                } else {
                    localStorage.removeItem('zoneFilter');
                }
            }
            return {
                ...state,
                zoneFilter: action.value
            };
        case SET_USER_FILTER:
            console.log('ZOO_REDUCER: Setting user filter to:', action.value);
            // Persister dans localStorage
            if (typeof window !== 'undefined' && window.localStorage) {
                if (action.value) {
                    localStorage.setItem('userFilter', JSON.stringify(action.value));
                } else {
                    localStorage.removeItem('userFilter');
                }
            }
            return {
                ...state,
                userFilter: action.value
            };
        case SET_ZOO_TIMEZONE:
            console.log('ZOO_REDUCER: Setting zoo timezone to:', action.value);
            return {
                ...state,
                timezone: action.value
            };
        case SET_ZOO_OPTIONS: {
            const options = action.value || {};
            // A reset is not a verified context. A late response must never switch parks.
            if (!Object.keys(options).length) return {
                ...state,
                zooOptions: {},
                productScopeReady: false,
                productScopeSelectionPending: Boolean(state.productScopeReady || state.productScopeSelectionPending),
                productScopeSelectionRevision: (state.productScopeSelectionRevision || 0) + 1,
            };
            if (options.zooId && options.zooId !== state.zooId && (state.productScopeReady || state.productScopeSelectionPending)) return state;
            const verified = Boolean(options.zooId);
            return {
                ...state,
                zooId: options.zooId || state.zooId,
                productScopeReady: verified || state.productScopeReady,
                productScopeSelectionPending: verified ? false : state.productScopeSelectionPending,
                // Settings forms may send an option patch without a zoo identity.
                // Preserve the verified scope; only a complete context replaces it.
                zooOptions: verified ? options : { ...state.zooOptions, ...options },
            };
        }
        case SET_ZOO_TYPE:
            return {
                ...state,
                zooType: action.value
            };
        case SET_AKONGO_STAFF:
            return {
                ...state,
                akongoStaff: action.value === true
            };
        default:
            return state;
    }
}

export default zooReducer;